export default "__VITE_ASSET__uBhKMU4W__"